import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBulletListRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4d4540",
		d: "M8 7.2c-.44 0-.8.36-.8.8v16c0 .44.36.8.8.8h16c.44 0 .8-.36.8-.8V8c0-.44-.36-.8-.8-.8zM4.8 8c0-1.765 1.436-3.2 3.2-3.2h16c1.766 0 3.2 1.435 3.2 3.2v16c0 1.765-1.434 3.2-3.2 3.2H8A3.203 3.203 0 0 1 4.8 24zm4.8 3.2c0-.885.716-1.6 1.6-1.6.886 0 1.6.715 1.6 1.6s-.714 1.6-1.6 1.6c-.884 0-1.6-.715-1.6-1.6m5.2 0c0-.665.536-1.2 1.2-1.2h4.8c.666 0 1.2.535 1.2 1.2s-.534 1.2-1.2 1.2H16c-.664 0-1.2-.535-1.2-1.2m0 4.8c0-.665.536-1.2 1.2-1.2h4.8c.666 0 1.2.535 1.2 1.2s-.534 1.2-1.2 1.2H16c-.664 0-1.2-.535-1.2-1.2m0 4.8c0-.665.536-1.2 1.2-1.2h4.8c.666 0 1.2.535 1.2 1.2s-.534 1.2-1.2 1.2H16c-.664 0-1.2-.535-1.2-1.2m-3.6-3.2c-.884 0-1.6-.715-1.6-1.6s.716-1.6 1.6-1.6c.886 0 1.6.715 1.6 1.6s-.714 1.6-1.6 1.6m-1.6 3.2c0-.885.716-1.6 1.6-1.6.886 0 1.6.715 1.6 1.6s-.714 1.6-1.6 1.6c-.884 0-1.6-.715-1.6-1.6"
	})
});
export default SvgBulletListRegularIcon;
